import React, { useState } from 'react';
import { Button, Logo, Field } from '../components/ui';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import api from '../api/client';

// Personal details collected right after a pro's OTP, before KYC.
// On "Next" it saves and the app gate advances to the verification screen.
export default function ProDetails() {
  const { user, refreshUser, setUser } = useAuth();
  const { toast } = useToast();
  const [form, setForm] = useState({
    name: user?.name || '',
    fatherHusbandName: '',
    alternateContact: '',
    email: user?.email || '',
    state: '',
    city: '',
    fullAddress: '',
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const next = async (e) => {
    e?.preventDefault();
    if (!form.name.trim()) return toast('Please enter your name', { tone: 'error' });
    if (!form.fatherHusbandName.trim()) return toast('Please enter Father / Husband name', { tone: 'error' });
    if (form.alternateContact && form.alternateContact.length !== 10) return toast('Alternate contact must be 10 digits', { tone: 'error' });
    if (!form.state.trim() || !form.city.trim()) return toast('Please enter your State & City', { tone: 'error' });
    if (!form.fullAddress.trim()) return toast('Please enter your full address', { tone: 'error' });

    setBusy(true);
    const payload = {
      name: form.name.trim(),
      email: form.email.trim(),
      proProfile: {
        fatherHusbandName: form.fatherHusbandName.trim(),
        alternateContact: form.alternateContact.trim(),
        state: form.state.trim(),
        city: form.city.trim(),
        fullAddress: form.fullAddress.trim(),
        completed: true,
      },
    };
    try {
      const d = await api.put('/users/me', payload);
      if (d?.user) setUser(d.user); else refreshUser();
      // The gate now advances to the verification (KYC) screen automatically.
    } catch (err) {
      toast(err.message || 'Please try again.', { title: 'Could not save', tone: 'error' });
      setBusy(false);
    }
  };

  return (
    <div className="app-shell">
      <div className="header-red" style={{ textAlign: 'center', paddingBottom: 22, borderRadius: '0 0 24px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}><Logo size="sm" /></div>
        <h1 style={{ fontSize: 22, fontWeight: 900, marginTop: 14, marginBottom: 0 }}>Your details</h1>
        <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginTop: 6, lineHeight: 1.4 }}>
          Step 1 of 2 — tell us about yourself. Next, you'll verify your ID.
        </p>
      </div>

      <div className="screen screen--plain" style={{ padding: 20, maxWidth: 560, margin: '0 auto', width: '100%' }}>
        <form className="card" onSubmit={next} style={{ borderRadius: 'var(--r-xl)', padding: 20 }}>
          <Field label="Full Name" value={form.name} onChange={set('name')} placeholder="Your name" autoComplete="name" />
          <Field label="Father / Husband Name" value={form.fatherHusbandName} onChange={set('fatherHusbandName')} placeholder="e.g. Ram Kumar" />
          <Field
            label="Alternate Contact No." value={form.alternateContact} inputMode="numeric" maxLength={10}
            placeholder="10-digit number"
            onChange={(e) => setForm((f) => ({ ...f, alternateContact: e.target.value.replace(/\D/g, '') }))}
          />
          <Field label="Email" value={form.email} onChange={set('email')} type="email" placeholder="you@example.com" autoComplete="email" />
          <div className="field-row">
            <Field label="State" value={form.state} onChange={set('state')} placeholder="Haryana" />
            <Field label="City" value={form.city} onChange={set('city')} placeholder="Gurugram" />
          </div>
          <Field as="textarea" label="Full Address" value={form.fullAddress} onChange={set('fullAddress')}
            placeholder="House / street / area / pincode" />

          <Button type="submit" title={busy ? 'Saving…' : 'Next  →'} disabled={busy} style={{ marginTop: 10 }} />
        </form>
      </div>
    </div>
  );
}
